import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../../../Translations';

interface Props {
  optionsLength: number;
}

const DateCount: React.FC<Props> = ({ optionsLength }) => (
  <T kind="{{count}} Date" count={optionsLength} />
);

export default observer(DateCount);
